import { reformatLocationString } from "./ReformatUtils";
import { getAayuCardActivityDatetime } from "./DateTimeUtils";

import { ProductCategoryMap } from "../constants/inventory-category";
import { SnackBarDescription, SnackBarIcon, SnackBarTitle } from "../constants/oms/SnackBarStatus";
import { OrderStatusColor, OrderStatusDescription, OrderStatusIcon, OrderStatusTitle } from "../constants/oms/OrderStatus";

export function extendUserSubscriptionData(subscriptionData, { userData }) {
    return {
        ...subscriptionData,
        userName: userData['name'],
        consultLeft: subscriptionData['maxConsultations'] -
            subscriptionData['consultedCount'],
        validFromDate: getAayuCardActivityDatetime(subscriptionData['addedOn']),
        validTillDate: getAayuCardActivityDatetime(subscriptionData['validTill'])
    }
}

export function extendChemistStoreData(chemistStoreData) {
    var dealData = {}
    if (chemistStoreData['pharmacyData']['deals']) {
        dealData['deals'] = chemistStoreData['pharmacyData']['deals']
        dealData['inventoryCount'] = chemistStoreData['pharmacyData']?.['inventoryCount'] ??
            chemistStoreData['pharmacyData']['deals'].length
    }
    var categoryList = []
    if (chemistStoreData['pharmacyData']['productCategories']) {
        let _list = chemistStoreData['pharmacyData']['productCategories']
        if (_list?.productCategories) categoryList = _list.productCategories
        else categoryList = _list ?? []
    }
    return {
        ...chemistStoreData['pharmacyData'],
        posters: chemistStoreData['posters'],
        dealsData: dealData,
        productCategories: categoryList,
    }
}

export function extendOMSOrderData(orderData) {
    let orderStatus = orderData['orderStatus']
    return {
        ...orderData,
        title: OrderStatusTitle[orderStatus],
        description: OrderStatusDescription[orderStatus],
        pharmacyData: orderData['pharmacies'][0],
        statusIcon: OrderStatusIcon[orderStatus],
        statusColor: OrderStatusColor[orderStatus]
    }
}

export function extendSnackBarData(orderData) {
    let orderStatus = orderData['orderStatus']
    return {
        ...orderData,
        title: SnackBarTitle[orderStatus],
        description: SnackBarDescription[orderStatus],
        statusIcon: SnackBarIcon[orderStatus],
        pharmacyData: orderData['pharmacies'][0],
    }
}

export function extendLocationData(locationData, {
    coordinates = null, isSavedLocation = true, isAddressDeleted = false }) {
    if (locationData['geocords'])
        coordinates = {
            latitude: locationData['geocords'][0],
            longitude: locationData['geocords'][1]
        }
    if (isSavedLocation) {
        let locationTitle = reformatLocationString(
            locationData['flat_and_building'], locationData['locality'])
        if (isAddressDeleted) {
            delete locationData['aid']
            delete locationData['name']
            delete locationData['locality']
            delete locationData['flat_and_building']
            return {
                ...locationData,
                isLocationFetched: false, isAddressCompleted: false,
                coordinates: coordinates, locationTitle: locationTitle,
            }
        } else return {
            ...locationData,
            isLocationFetched: true, isAddressCompleted: true,
            coordinates: coordinates, locationTitle: locationTitle,
        }
    } else {
        let locationTitle = ''
        let address = ''
        if (locationData['subLocality']) {
            address = locationData['address']
            locationTitle = locationData['subLocality']
        } else {
            locationTitle = locationData['mtxt']
            address = locationData['mtxt'] + ', ' + locationData['stxt']
        }
        return {
            ...locationData,
            locationTitle: locationTitle, address: address,
            isLocationFetched: true, isAddressCompleted: false,
            pid: locationData['placeId'] ?? locationData['pid']
        }
    }
}

export const extendAddressDataList = (addressList) => {
    addressList.forEach((address: any) => {
        let location = address['location']
        let splitLocation = location.split(',')
        address['coordinates'] = {
            latitude: splitLocation[0],
            longitude: splitLocation[1]
        }
        address['isAddressCompleted'] = true
    })
    return addressList
}

export const extendProductCategoryData = (category) => {
    let extendedData = ProductCategoryMap[category.cid]
    return { ...category, ...extendedData }
}